import React from 'react';
import PropTypes from 'prop-types';

import M2PlatformGeneratedScreeningQuestions from '@zr/jobseeker-public/apps/jobseeker/screening-questions/PlatformGenerated/components/M2PlatformGeneratedScreeningQuestions';
import {
  PLATFORM_SUGGESTIONS,
  platformSuggestionsPropTypes,
} from '../../../screenTypeSchema';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';

import screenTypeTelemetry from '../screenTypeTelemetry';

export function PlatformSuggestions({
  applyData,
  onScreenTypeFinish,
  screenTypeParameters,
  setIsLoading,
}) {
  const {
    enc_quiz_id: encQuizId,
    ip_country_code: ipCountryCode,
    location_autocomplete_url: locationAutocompleteUrl,
    num_suggestions_complete: numSuggestionsComplete,
    response_id: responseId,
    skill_limit: skillLimit,
    suggestions,
    total_screening_questions: totalScreeningQuestions,
    enc_response_id: encResponseId,
  } = screenTypeParameters;

  const {
    logInteraction,
    logView,
  } = screenTypeTelemetry(PLATFORM_SUGGESTIONS, applyData);

  const handleSuggestionAnswer = ({
    answer,
    complete,
    ...rest
  }) => {
    logInteraction((answer === 'skipped') ? 'skip' : 'continue', {
      finished_screen_type: !!complete,
      ...rest,
    });
  };

  const handleSuggestionView = (eventData) => {
    logView(eventData);
  };

  const finish = async () => {
    // no need to log finished_screen_type here, because handleSuggestionAnswer will log each interaction and if its finished
    await onScreenTypeFinish();
  };

  return (
    <M2PlatformGeneratedScreeningQuestions
      encQuizId={encQuizId}
      encResponseId={encResponseId}
      ipCountryCode={ipCountryCode}
      locationAutocompleteUrl={locationAutocompleteUrl}
      numSuggestionsComplete={numSuggestionsComplete}
      onDone={finish}
      onSuggestionAnswer={handleSuggestionAnswer}
      onSuggestionView={handleSuggestionView}
      responseId={responseId}
      skillLimit={skillLimit}
      suggestions={suggestions}
      totalScreeningQuestions={totalScreeningQuestions}
      setIsLoading={setIsLoading}
    />
  );
}

PlatformSuggestions.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeParameters: platformSuggestionsPropTypes.isRequired,
  setIsLoading: PropTypes.func,
};

PlatformSuggestions.defaultProps = {
  setIsLoading: () => {},
};

export default PlatformSuggestions;
